import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { MultiBorrowersAddressHistoryComponent } from "../../wizard/wizard-steps/multiborrowers-address-history-step/multiborrowers-address-history-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class MultiBorrowersAddressHistoryStep extends WizardStepBase {
  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = MultiBorrowersAddressHistoryComponent;
  }
}
